// قوانين مدرسة قياسات الفوضى التراكمية
const rawLaws = [
  {
    id: 'LAW_001',
    number: 1,
    category: 'مدرسة',
    title: 'معنى «لا شك فيها» ليس حتمية',
    summary: 'تصنيف «لا شك» يعني أعلى درجة ترجيح وليس ضمانًا جبريًا.',
    details: 'ورد نصًا أن «لا شك فيها لا تعني الحتمية والجبريّة»، أي أن التصنيف لا يلغي إدارة المخاطر ولا يلغي احتمال انعكاس أو تغير بيئة.',
    conditions: [
      'استخدمه كقانون ذهني عند قراءة أي إشارة «لا شك».',
      'لا تحول «لا شك» إلى يقين مطلق يمنع الالتزام بالوقف والقواعد الأخرى.'
    ],
    expectedResults: [
      'تقليل سلوك العناد ضد السوق عند فشل الإشارة.',
      'الالتزام بالوقف حتى مع قوة الترجيح.'
    ],
    example: 'حتى لو كانت الإشارة «لا شك»، تُطبّق الوقف/عكس الوقف وتُراجع البيئة عند ضرب الوقف بدل الإصرار على الحتمية.',
    sources: ['ID: 79020 | 15.01.2026'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_002',
    number: 2,
    category: 'مدرسة',
    title: 'قاعدة الانضباط: اشتغل على «لا شك» واترك «المشكوك»',
    summary: 'اتخاذ القرار يُبنى على الانضباط لا على مطاردة كل حالة.',
    details: 'ورد توجيه عملي: «اشتغل على لا شك فيها… واترك المشكوك فيها…» حتى لو حدثت مفارقات بأن المشكوك قد يصدق واللاشك قد يكذب. المقصود هو الانضباط وليس إثبات أن كل لاشك ينجح.',
    conditions: [
      'عند تعدد السيناريوهات: اختر ما تم تصنيفه لا شك وفق قوانين المدرسة.',
      'تعامل مع المشكوك كمعلومة رصد/متابعة لا كصفقة أساسية.'
    ],
    expectedResults: [
      'تقليل الدخول العشوائي في البيئات المشكوك فيها.',
      'تحسين الالتزام بتسلسل القوانين.'
    ],
    example: 'في «التداخل» (المذكور أنه دائمًا مشكوك) لا تُعامل الحركة كفرصة كسر مؤكدة بل تنتظر بيئة أو ناقل واضح.',
    sources: ['ID: 53608 | 25.10.2024', 'ID: 79020 | 15.01.2026'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_003',
    number: 3,
    category: 'مدرسة',
    title: 'قانون إدارة الاحتمالات بالوقف وعكس الوقف',
    summary: 'استخدم الوقف كآلية لإدارة السيناريوهات بدل الانحياز لاتجاه واحد.',
    details: 'تصف الرسائل منطق المدرسة بأنه يقوم على قانون «وقف البيع شراء ووقف الشراء بيع» كميزة فارقة، ويُعرض كطريقة للتعامل مع الاحتمالات (صياغة أحدث: تحويلها إلى 33/33/33 بدل كسرها).',
    conditions: [
      'عند أخذ أي صفقة بناءً على المدرسة: يجب أن يكون لديك وقف واضح.',
      'عند ضرب الوقف: يتم التعامل مع «عكس الوقف» كجزء من السيناريو وليس «خطأ» في القانون.'
    ],
    expectedResults: [
      'التحول للاتجاه المقابل وفق مستويات المؤشر/القانون عند ضرب الوقف.',
      'إدارة احتمالات متوازنة بدل الانحياز.'
    ],
    example: 'مثال أحدث: التأكيد أن المدرسة لم «تكسر» الاحتمالات لكنها تجعلها 33/33/33.',
    sources: ['ID: 78794 | 09.01.2026', 'ID: 78079 | 11.12.2025'],
    chartRecipeSources: 'نص الوقف وعكس الوقف وارد في مصادر القانون أعلاه.',
    chartRecipe: {
      inputs: ['entryPrice', 'stopPrice', 'direction'],
      overlays: [
        {
          type: 'marker',
          value: 'input(entryPrice)',
          label: 'دخول',
          direction: 'input(direction)'
        },
        {
          type: 'priceLine',
          value: 'input(stopPrice)',
          label: 'وقف/عكس',
          color: '#d32f2f'
        },
        {
          type: 'marker',
          value: 'input(stopPrice)',
          label: 'عكس',
          color: '#d32f2f',
          shape: 'arrow'
        }
      ]
    },
    tutorialSteps: [
      { text: 'اختر نقطة دخول افتراضية على الشارت.', assigns: 'entryPrice' },
      { text: 'حدد مستوى الوقف أعلى/أسفل الدخول حسب الاتجاه.', assigns: 'stopPrice' },
      { text: 'راقب أن ضرب الوقف يعني عكس الاتجاه وفق القانون.' }
    ]
  },
  {
    id: 'LAW_004',
    number: 4,
    category: 'مدرسة',
    title: 'قانون الخادش: (تعريف) ثم (رفض مبدئي)',
    summary: 'النسخة الحالية ترفض الخادش مبدئيًا لأنه يفسد توقع الأهداف.',
    details: 'وردت رسالة تشرح أن الخادش لا بد أن يظهر اتزانه الطبيعي أو القياسي، فإذا رأيت اتزانه تتوقع سيره. ثم وردت رسالة أحدث: «نحن مبدايا نرفض الخادش… لاننا لانستطيع ان نتوقع مسير السعر واهدافه فقد حصل خلل».',
    conditions: [
      'النسخة الحالية: تجنّب الدخول على الخادش كقاعدة أولى.',
      'إذا اضطررت لقراءته: ابحث عن عودة الاتزان قبل بناء توقعات.'
    ],
    expectedResults: [
      'تجنب بيئة يصعب توقع أهدافها بسبب الخلل.',
      'تقليل الدخول في مناطق غير قابلة للقياس.'
    ],
    example: 'إذا حُددت الحالة كخادش، تُعامل كتحذير من خلل وأن الأهداف غير قابلة للتوقع بسهولة.',
    sources: ['ID: 77130 | 28.10.2025', 'ID: 77135 | 28.10.2025'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_005',
    number: 5,
    category: 'مدرسة',
    title: 'السعر اتزانات خاضعة لرياضيات الفوضى وليس «لعبة فريقين»',
    summary: 'تفسير المدرسة للحركة مبني على الاتزان لا على صراع ثنائي.',
    details: 'توجد رسائل صريحة أن السعر ليس لعبة كرة بين فريقين، بل «اتزانات خاضعة لرياضيات الفوضى» وأن ذلك يحتاج قوانين ومهارة. هذا يشكل فلسفة المدرسة ويبرر التركيز على القياس بدل الأخبار/العاطفة.',
    conditions: [
      'استخدم هذا القانون كإطار ذهني للتعلم: هدفك اكتشاف الاتزان/البيئة/الناقل.',
      'تجنب تفسير الحركة كتوقعات خبرية أو صراع ثنائي.'
    ],
    expectedResults: [
      'تحويل التركيز إلى القياس المنهجي بدل الانطباعات.',
      'اتساق أكبر مع قوانين المدرسة.'
    ],
    example: 'ربط الاتزان بـ 0.236 والبحث عنه باعتباره محور فهم الأبعاد.',
    sources: ['ID: 73276 | 11.08.2025', 'ID: 73352 | 11.08.2025'],
    chartRecipeSources: 'الربط بين الاتزان و0.236 مذكور في المثال النصي.',
    chartRecipe: {
      inputs: ['rangeLow', 'rangeHigh'],
      overlays: [
        {
          type: 'priceLine',
          value: 'ratio(0.236)',
          label: 'اتزان 0.236',
          color: '#2e7d32'
        }
      ]
    },
    tutorialSteps: []
  },
  {
    id: 'LAW_006',
    number: 6,
    category: 'مدرسة',
    title: 'قانون البيئات القياسية: السعر يسير على بيئات… والمهارة اكتشافها',
    summary: 'التطبيق يبدأ بتحديد البيئة القياسية التي يسير عليها السعر.',
    details: 'الرسائل تذكر أن السعر يسير على عدة بيئات قياسية متغيرة، وأن المهارة هي اكتشاف البيئة. كما تسرد البيئات: (تجاذب، انحراف مزدوج، تمحور، قطع ناقص، تمحور خلفي، قطع ناقص خلفي، رأس حربة، زاوية) وتضيف قاعدة: إذا كانت البيئة «لا شك» وفشلت/انقلبت فهذا «يغضب» (انعكاس قوي)، مع وصية: احترم القانون، لا تعامله كعدو.',
    conditions: [
      'في بداية التحليل: حدد البيئة الحالية عبر قوانينها.',
      'ميز بين بيئة «لا شك» و«مشكوك» قبل الدخول.',
      'عند فشل «لا شك»: توقّع انعكاسًا قويًا وفق النص.'
    ],
    expectedResults: [
      'تحسين دقة التشخيص البيئي قبل الدخول.',
      'تقليل الدخول العاطفي في بيئات غير واضحة.'
    ],
    example: 'بعد «تداخل» (مشكوك) تتوقع ظهور «تجاذب» وفق القاعدة المذكورة.',
    sources: ['ID: 71505 | 21.03.2025', 'ID: 68580 | 17.02.2025'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_007',
    number: 7,
    category: 'مدرسة',
    title: 'قوانين النواقل: الناقل الحاصل + الناقل أثناء التكوين',
    summary: 'التحليل الصحيح يُبنى على «ناقل حاصل» ويؤكده ناقل أثناء التكوين.',
    details: 'وردت عبارات مباشرة مثل: «التحليل الصحيح هو ناقل حاصل 0.236»، وأن قوانين النواقل تغني عن الحيرة. ووردت قاعدة توثيقية: لكي تقول «ناقل حاصل … لا شك فيه» يجب أن ترى زاوية واضحة حاصلة بعد أن تنتهي الوحدة، وتم لمس/كسر 1.236 في سياق قانون الزاوية. وورد تركيب: «ناقل حاصل أكده ناقل أثناء التكوين».',
    conditions: [
      'لا تعتمد على «ناقل حاصل» إلا بعد انتهاء/إغلاق الوحدة الزمنية ورؤية الشرط البصري.',
      'يمكن استخدام الناقل أثناء التكوين كتأكيد/تمهيد خصوصًا إذا أكد ناقل حاصل.'
    ],
    expectedResults: [
      'تقليل سوء التصنيف بين الحاصل وأثناء التكوين.',
      'قراءة أكثر اتساقًا للبيئة عبر شروط الزاوية.'
    ],
    example: 'ذكر أن «ناقل حاصل أكده ناقل أثناء التكوين» يعني أن المتداول يرى منطقة عودة الأمل بعد أن تقطعت به الأسباب.',
    sources: ['ID: 68748 | 18.02.2025', 'ID: 66975 | 05.02.2025', 'ID: 50024 | 13.10.2024'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_008',
    number: 8,
    category: 'مدرسة',
    title: 'قانون التداخل',
    summary: 'التداخل لا يكسر دعم ولا يخترق مقاومة، وهو دائمًا مشكوك وبعده تجاذب.',
    details: 'ورد نصًا: «التداخل لا يكسر دعم ولا يخترق مقاومه»، و«التداخل دائما مشكوك فيه»، و«دائما نتوقع ان يظهر بعد التداخل تجاذب». كما ورد هدف للتداخل: «100 +0.382».',
    conditions: [
      'عند الاشتباه أن الحركة تداخل: لا تبنِ قرارك على كسر/اختراق.',
      'صنّفه كمشكوك وانتظر انتقالًا لبيئة أخرى.',
      'راقب توقع ظهور التجاذب بعده.'
    ],
    expectedResults: [
      'تصفية الدخول العشوائي داخل مناطق غير حاسمة.',
      'تحسين قراءة التسلسل البيئي بعد التداخل.'
    ],
    example: 'إذا رأيت حركة جانبية بدون كسر دعم/مقاومة، اعتبرها تداخل ولا تدخل على فكرة كسر.',
    sources: ['ID: 47602 | 03.10.2024', 'ID: 68193 | 14.02.2025', 'ID: 68727 | 18.02.2025'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_009',
    number: 9,
    category: 'مدرسة',
    title: 'قانون الوحدة الزمنية الثابتة: أساس القياس',
    summary: 'ابدأ/ابنِ قياسك على «الوحدة الزمنية الثابتة».',
    details: 'تكررت عبارات تؤكد أن «سر الأسرار» هو الوعي بالوحدة الزمنية الثابتة، وأن عدم الالتزام بها يُدخل في متاهة قياسية لا تنتهي، وأنها «الواقع الحقيقي الذي جرى عليه التداول». وفي سياق تطوير القواعد: «الوحدة الزمنية الثابتة تغنيك عن التباطؤ والتسارع».',
    conditions: [
      'عند اختلاف القياسات بين الفريمات: ارجع للوحدة الزمنية الثابتة كمرجع.',
      'عند قراءة ناقل «حاصل»: انتظر نهاية/إغلاق الوحدة الزمنية.',
      'استخدم الوحدة الثابتة كنقطة تثبيت قبل تفاصيل البيئات.'
    ],
    expectedResults: [
      'تقليل التناقض القياسي بين الفريمات.',
      'تحسين موثوقية تحديد النواقل والبيئات.'
    ],
    example: 'رسائل متعددة تصف أفضل التحليل أنه على الوحدة الزمنية الثابتة وتربطها بواقع التداول.',
    sources: ['ID: 66868 | 05.02.2025', 'ID: 66904 | 05.02.2025', 'ID: 67765 | 11.02.2025'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_010',
    number: 10,
    category: 'مدرسة',
    title: 'قانون التمحور',
    summary: 'التمحور يأتي بعد الانحراف المزدوج ويُقرأ عند 0.236 مع هدف أول 0.382.',
    details: 'ورد تعريف تسلسلي: «التمحور هو من بعد الانحراف المزدوج». كما وردت عبارة: «نفترض ان التمحور هو 0.236»، و«على بيئة التمحور دائما نتوقع يوم الانعكاس»، و«التمحور نتوقع ان يكون هدفه الاول 0.382».',
    conditions: [
      'لا تُسمي تمحورًا قبل تحقق سياقه (بعد الانحراف المزدوج).',
      'استخدم 0.236 كمرجع تمحور.',
      'راقب هدف 0.382 كأول هدف محتمل.'
    ],
    expectedResults: [
      'قراءة أكثر انضباطًا لسلوك الانعكاس بعد الانحراف المزدوج.',
      'تحديد أهداف أولية واضحة.'
    ],
    example: 'بعد ظهور خصائص الانحراف المزدوج، إن ظهرت إشارات تمحور فالأولوية لتوقع يوم انعكاس.',
    sources: ['ID: 63537 | 28.12.2024', 'ID: 67088 | 06.02.2025', 'ID: 67655 | 11.02.2025'],
    chartRecipeSources: '0.236 مرجع التمحور والهدف الأول 0.382 وفق نص القانون.',
    chartRecipe: {
      inputs: ['rangeLow', 'rangeHigh'],
      overlays: [
        {
          type: 'priceLine',
          value: 'ratio(0.236)',
          label: 'تمحور 0.236',
          color: '#1565c0'
        },
        {
          type: 'priceLine',
          value: 'ratio(0.382)',
          label: 'هدف 0.382',
          color: '#2e7d32'
        }
      ]
    },
    tutorialSteps: []
  },
  {
    id: 'LAW_011',
    number: 11,
    category: 'مدرسة',
    title: 'قانون التباطؤ الزمني والتسارع: (نسخة أقدم) ثم مركزية الوحدة الثابتة',
    summary: 'كان: الزمن متسارع/متباطئ للتصحيح. أصبح: الوحدة الثابتة تغني عنه.',
    details: 'توجد رسائل أقدم تربط التحليل بتوقع أن الزمن «إما متسارع أو متباطئ»، وأن هناك «قانون التباطؤ الزمني للتصحيح». وفي رسالة لاحقة ضمن سياق الوحدة الزمنية الثابتة: «الوحده الزمنيه الثابته تغنيك عن التباطؤ والتسارع».',
    conditions: [
      'النسخة الحالية: لا تجعل التباطؤ/التسارع أساس القرار إذا كنت تعمل بالوحدة الزمنية الثابتة.',
      'النسخة السابقة: كان التباطؤ/التسارع يُستخدم لتوقع التصحيح.'
    ],
    expectedResults: [
      'التركيز على الوحدة الزمنية الثابتة كمرجع أساس.',
      'تقليل التشوش الناتج عن فرضية التسارع/التباطؤ.'
    ],
    example: 'مثال قديم: ربط التباطؤ بتجاوز 1.236 في سياق محدد، ثم الاستغناء عنه بعد ضبط الوحدة الثابتة.',
    sources: ['ID: 65527 | 15.09.2024', 'ID: 58470 | 25.08.2024', 'ID: 66894 | 05.02.2025'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_012',
    number: 12,
    category: 'مدرسة',
    title: 'قانون القطع الناقص الخلفي',
    summary: 'قطع ناقص خلفي يتطلب امتداد طول الوحدة إلى 2.764 أو ثلاثة أضعاف الوحدة السابقة.',
    details: 'وردت قاعدة: «ولكي يظهر قطع ناقص خلفي يجب ان يصل طوله الى 2.764». ووردت قاعدة أخرى: «يصل طوله ثلاث اضعاف الوحده التي قبله فيظهر لنا قطع ناقص خلفي»، وكذلك ورد توصيف أنه إذا ظهر نتوقع أن تمتد الوحدة لأكثر من ضعفي ما قبلها لتشكل قطع ناقص خلفي.',
    conditions: [
      'استخدم قياس طول الوحدة لمراقبة الوصول إلى 2.764.',
      'راقب أيضًا وصف «أكثر من ضعفي» و«ثلاث أضعاف» كدلائل إضافية.'
    ],
    expectedResults: [
      'تحسين تحديد تشكل القطع الناقص الخلفي وفق الشروط الرقمية.',
      'تقليل اللبس بين القطع الناقص الخلفي وبقية البيئات.'
    ],
    example: 'إذا كانت وحدة ما طولها ضعف سابقتها ثم استمرت للزيادة، هذا قد يُقرأ ضمن مسار تشكل قطع ناقص خلفي.',
    sources: ['ID: 59916 | 25.11.2024', 'ID: 64437 | 04.01.2025', 'ID: 57164 | 11.11.2024'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_013',
    number: 13,
    category: 'مدرسة',
    title: 'قانون رأس الحربة',
    summary: 'رأس حربة متكون من تمحور أمامي وخلفي، وأفضل شكل متساوي الكتفين تقريبًا.',
    details: 'ورد وصف بنيوي: «راس حربه متكون من تمحور امامي خلفي». ووردت ملاحظة جودة: أفضل رأس حربة متساوي الكتفين تقريبًا، ووردت قاعدة تحول إلى «لا شك» عند لمس ثم هبوط سريع.',
    conditions: [
      'اعتمد التسمية البنيوية (أمامي/خلفي).',
      'راقب توازن الكتفين كمؤشر جودة للشكل.',
      'إذا حدث لمس ثم هبوط سريع يمكن إعادة تصنيفها «لا شك» وفق النص.'
    ],
    expectedResults: [
      'تحسين توصيف جودة رأس الحربة قبل الدخول.',
      'تقليل الالتباس بين رأس الحربة وبقية البيئات.'
    ],
    example: 'بعد نهاية اليوم يمكن رسم رأس حربة للتوقع (ورد ذكر رسم بعد انتهاء اليوم).',
    sources: ['ID: 39530 | 19.07.2024', 'ID: 59446 | 23.11.2024', 'ID: 59018 | 22.11.2024'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_014',
    number: 14,
    category: 'مدرسة',
    title: 'قانون الاندفاع/الانزلاق الفاشل واحترام 1.236',
    summary: 'تمييز «الفاشل» أساسه عدم الوصول أو عدم احترام 1.236.',
    details: 'ورد تعريف مباشر للانزلاق الفاشل: كسر الدعم التقليدي ولا يصل إلى 1.236. كما ورد تعريف للاندفاع المرهق (لم يصل للمقاومة التقليدية) وذُكر أن حدوث الاندفاع الفاشل غالبًا يعني عدم احترام 1.236. وتوجد قاعدة إضافية أن ناقل أثناء التكوين يجب ألا يسبقه انزلاق فاشل أو اندفاع فاشل.',
    conditions: [
      'عند كسر دعم/اختراق مقاومة: راقب هل وصلت الحركة لـ 1.236 أم لا لتحديد «فاشل».',
      'عند العمل بناقل أثناء التكوين: تحقّق أنه غير مسبوق بفاشل.'
    ],
    expectedResults: [
      'تحسين التمييز بين الانزلاق الفاشل والاحترام القياسي.',
      'تصفية قرارات ناقل أثناء التكوين وفق الشرط المذكور.'
    ],
    example: 'إذا كسر السعر دعمًا ثم عاد قبل 1.236 فهذا يوصف كـ «انزلاق فاشل».',
    sources: ['ID: 59050 | 27.08.2024', 'ID: 47594 | 03.10.2024', 'ID: 57591 | 12.11.2024'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_015',
    number: 15,
    category: 'مدرسة',
    title: 'قانون الزاوية (شروط رقمية) + حد الانحراف المزدوج',
    summary: 'الزاوية لها شروط رقمية، والانحراف المزدوج لا يتشكل بزاوية أقل من 0.66.',
    details: 'ورد قانون صريح أن «الزاوية التي تنتهي على زاوية» يجب أن تكون أكبر من 0.236 وأقل من 0.666، وأن تلمس/تكسر 1.236. كما وردت قاعدة مستقلة: «الانحراف المزدوج لا يتشكل بزاوية أصغر من 0.66».',
    conditions: [
      'عند تصنيف «زاوية» أو اعتماد ناقل حاصل: راجع شروط الزاوية.',
      'عند محاولة تسمية حالة بانحراف مزدوج: تأكد أن الزاوية ليست أقل من 0.66.'
    ],
    expectedResults: [
      'توحيد شروط تصنيف الزوايا وفق الحدود الرقمية.',
      'تجنب تصنيف انحراف مزدوج بزاوية غير صحيحة.'
    ],
    example: 'ربط ظهور زاوية واضحة بعد نهاية الوحدة لإعلان ناقل حاصل لا شك فيه.',
    sources: ['ID: 57530 | 09.08.2024', 'ID: 45717 | 26.09.2024', 'ID: 50024 | 13.10.2024'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_016',
    number: 16,
    category: 'مدرسة',
    title: 'قانون الملامس',
    summary: 'لا تُسمّي «ملامس» إلا إذا تكررت اللمسة (مرتين+) وبفاصل.',
    details: 'من شروط «الملامس» أن يكون ملامسًا لنسبة مرتين أو أكثر، وأن تكون اللمسات متباعدة (لا تأتي متتالية مباشرة).',
    conditions: [
      'استخدم القانون لتصفية اللمسات العشوائية/الوحيدة.',
      'افصل بين لمسٍ ولمسٍ بزمن/حركة واضحة.'
    ],
    expectedResults: [
      'رفع جودة تعريف الملامس داخل القياسات.',
      'تقليل الاعتماد على لمسة واحدة كمعلومة حاسمة.'
    ],
    example: 'إذا لامس السعر نسبة 0.382 مرتين خلال فترات مختلفة تُعتبر ملامسًا، أما لمس سريع متتالٍ فلا.',
    sources: ['ID: 58834 | 27.08.2024'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_017',
    number: 17,
    category: 'مؤشر',
    title: 'الملكية الفكرية للمؤشر ومنع نسخه/تداوله',
    summary: 'المؤشر حقوق ملكية فكرية ولا يُسمح بنسخه أو ادعاء ملكيته.',
    details: 'وردت رسائل تؤكد أن المؤشر ملكية فكرية مسجلة وأن نسخة المؤشر تُعد تعديًا. هذا يضع قانونًا تنظيميًا لاستخدام المؤشر.',
    conditions: [
      'لا تنسخ المؤشر ولا تعيد توزيعه.',
      'إذا كنت تستخدمه ضمن خدمة/اشتراك فالتزم بشروط المصدر.'
    ],
    expectedResults: [
      'التزام قانوني وأخلاقي بحقوق الملكية.',
      'تجنب التعرض لمخالفات حقوقية.'
    ],
    example: 'التحذير بأن نسخ المؤشر وتوزيعه يُعد انتهاكًا للملكية الفكرية.',
    sources: ['ID: 79040 | 18.01.2026', 'ID: 78988 | 15.01.2026'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_018',
    number: 18,
    category: 'مؤشر',
    title: 'وحدات زمنية للسكالبنج/الأوبشن داخل خدمة المؤشر',
    summary: '1 دقيقة = 60 ثانية، و5 دقائق ثابتة = 300 ثانية للسكالبنج/الأوبشن.',
    details: 'وردت رسالة منقولة تشرح أن مؤشرات الأوبشن تعتمد على قراءة 1 دقيقة (60 ثانية) و5 دقائق ثابتة (300 ثانية) في سياق السكالبنج/الأوبشن.',
    conditions: [
      'يُستخدم هذا عند تطبيق المدرسة على الأوبشن/السكالبنج فقط.',
      'المعلومة جاءت في رسالة منقولة من خدمة مؤشر.'
    ],
    expectedResults: [
      'توحيد قراءة الفريمات الرقمية للسكالبنج/الأوبشن.',
      'تجنب الالتباس بين الوحدات الزمنية الثابتة.'
    ],
    example: 'اختيار فريم 1m أو 5m وفق احتياج السكالبنج.',
    sources: ['ID: 79028 | 15.01.2026'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_019',
    number: 19,
    category: 'مؤشر',
    title: 'آلية الحصول على المؤشر ودعم القناة بالصدقة (تغيّر)',
    summary: 'النموذج تغيّر من صدقة واشتراك إلى 200$ مع دورة تدريبية.',
    details: 'ورد نموذج دعم بالصدقة: «تتصدق ب10 دولار… بنية شراء المؤشر»، ثم ذكر اشتراك «20 دولار بالشهر». وفي أحدث الرسائل ذُكر: «200 دولار مع دوره تدريبيه بقوانين قياسات الفوضى التراكميه».',
    conditions: [
      'اتبع آخر إعلان سعر/طريقة داخل الرسائل باعتباره النسخة الحالية.',
      'لا تعتبر الأرقام ثابتة عبر الزمن لأنها تغيّرت بالفعل.'
    ],
    expectedResults: [
      'الاعتماد على أحدث نسخة معلنة من آلية الحصول على المؤشر.',
      'تجنّب الالتباس بسبب تغير الشروط بمرور الوقت.'
    ],
    example: 'تطبيق النموذج القديم كان يتم عبر صدقة محلية بنية شراء المؤشر، ثم تحوّل إلى 200$ مع دورة.',
    sources: ['ID: 55027 | 19.07.2024', 'ID: 55917 | 22.07.2024', 'ID: 78980 | 15.01.2026'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_020',
    number: 20,
    category: 'مؤشر',
    title: 'حالة التطوير: «تم الانتهاء من جميع التعديلات»',
    summary: 'إشارة إلى اكتمال تعديلات/تحديثات المؤشر في وقت الرسالة.',
    details: 'وردت رسالة قصيرة: «تم الانتهاء من جميع التعديلات». تُعامل كإشارة أن نسخة المؤشر/القواعد كانت تمر بتعديل، وأنه تم إنهاء تلك التعديلات بتاريخ الرسالة.',
    conditions: [
      'يُستخدم كبند زمني في الـ Timeline أكثر من كونه قانون تداول مباشر.'
    ],
    expectedResults: [
      'تحديد النسخة المستقرة بحسب تاريخ الرسالة.',
      'تجنّب الاعتماد على نسخة سابقة بعد إعلان الانتهاء من التعديلات.'
    ],
    example: 'اعتبار ما بعد هذا التاريخ هو النسخة المستقرة حتى يظهر تحديث أحدث.',
    sources: ['ID: 78979 | 15.01.2026'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_021',
    number: 21,
    category: 'مؤشر',
    title: 'المربعات القياسية',
    summary: 'المربع القياسي مرجع قراءة الإغلاق والألوان المرتبطة بنسبة 0.50.',
    details: 'يظهر مفهوم «مربع قياسي» يُقاس عليه، وتوجد قواعد لقراءة ألوان المربع وفق إغلاقه نسبة إلى 0.50.',
    conditions: [
      'استخدم المربع القياسي كمرجع بصري لقراءة الإغلاق.',
      'اربط قراءة اللون بنسبة 0.50 كما وردت القاعدة.'
    ],
    expectedResults: [
      'توحيد قراءة المربعات وفق نسبة الإغلاق.',
      'اختصار بصري سريع لحالة الإغلاق.'
    ],
    example: 'قاعدة الألوان (أبيض/أصفر) حسب الإغلاق تحت/فوق 0.50.',
    sources: ['ID: 57574 | 09.08.2024', 'ID: 67489 | 19.09.2024', 'ID: 67490 | 19.09.2024'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_022',
    number: 22,
    category: 'مؤشر',
    title: 'المربعات الرمادية = مناطق الجذب',
    summary: 'المربعات الرمادية تُستخدم لتحديد مناطق الجذب.',
    details: 'ورد نصًا: «تحديد مناطق الجذب المربعات الرماديه».',
    conditions: [
      'عند البحث عن مناطق جذب/تجاذب: راقب أماكن المربعات الرمادية.'
    ],
    expectedResults: [
      'تحديد مناطق الجذب بصريًا عبر المربعات الرمادية.'
    ],
    example: 'إذا اقترب السعر من مربع رمادي تُعتبر منطقة مرشحة للجذب وفق التسمية.',
    sources: ['ID: 78889 | 13.01.2026'],
    chartRecipeSources: 'المصدر يذكر المربعات الرمادية كمناطق جذب دون تحديد خوارزمية الرسم.',
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: ['حدد المربعات الرمادية يدويًا على الشارت إذا كانت ظاهرة في المؤشر.']
  },
  {
    id: 'LAW_023',
    number: 23,
    category: 'مؤشر',
    title: 'حد أقصى لمستويات الدعم/المقاومة القياسية (R0-R2 / S0-S2)',
    summary: 'لا يمكن ظهور أكثر من 3 مستويات R أو 3 مستويات S وفق الرسالة.',
    details: 'ورد نصًا أنه «لا يمكن ان يظهر اكثر من R0 R1 R2 / S0 S1 S2»، أي أن تمثيل الدعوم/المقاومات القياسية محدود بهذا العدد.',
    conditions: [
      'عند قراءة الدعوم/المقاومات داخل إطار المدرسة: لا تتوقع أكثر من ثلاث مستويات من نفس النوع.',
      'استخدم ذلك كفلتر ضد الإفراط في رسم مستويات كثيرة.'
    ],
    expectedResults: [
      'تقليل زحمة المستويات على الشارت.',
      'تحسين وضوح القراءة القياسية.'
    ],
    example: 'إذا رأيت مستويات R0 وR1 وR2 فلا تنتظر R3 ضمن نفس التمثيل القياسي.',
    sources: ['ID: 78851 | 11.01.2026'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_024',
    number: 24,
    category: 'مؤشر',
    title: 'المؤشر يعطي: إشارة + هدف + وقف + عكس الوقف',
    summary: 'اتبع مخرجات المؤشر الأربع كما وردت.',
    details: 'ورد نصًا أن المؤشر «يعطي إشارات بيع وشراء وهدف ووقف وعكس الوقف». هذه هي الوظائف التشغيلية الأساسية للمؤشر كما وردت في النص.',
    conditions: [
      'عند ظهور إشارة بيع/شراء: اقرأ الهدف والوقف المصاحب.',
      'عند ضرب الوقف: تعامل مع «عكس الوقف» كجزء من السيناريو.'
    ],
    expectedResults: [
      'قراءة منظمة لمخرجات المؤشر.',
      'التزام بسيناريو الوقف وعكسه.'
    ],
    example: 'صفقة بيع + هدف + وقف؛ إذا ضرب الوقف تنتقل لتطبيق عكس الوقف بدل الانهيار النفسي.',
    sources: ['ID: 77838 | 26.11.2025', 'ID: 78794 | 09.01.2026'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_025',
    number: 25,
    category: 'مؤشر',
    title: 'قراءة ألوان المربعات حسب إغلاق 0.50',
    summary: 'إغلاق المربع تحت 0.50 = أبيض، وفوق 0.50 = أصفر.',
    details: 'وردت قاعدة نصية: «المربع الي اغلاقو تحت 0.50 لونو ابيض» و«المربع الي اغلاقو فوق 0.50 لونو اصفر»، وورد تنبيه أن «ألوان المربعات غلط» في رسالة بنفس السياق ما يعني احتمال خطأ تطبيقي/عرضي في بعض النسخ.',
    conditions: [
      'استخدم لون المربع كاختصار لحالة الإغلاق بالنسبة لـ 0.50.',
      'تعامل مع اللون كإشارة مساعدة لا وحيدة بسبب التنبيه المذكور.'
    ],
    expectedResults: [
      'قراءة أسرع لحالة الإغلاق عبر اللون.',
      'تقليل الاعتماد على اللون وحده بسبب احتمال خطأ عرضي.'
    ],
    example: 'رؤية مربع أبيض = إغلاق تحت 0.50؛ مربع أصفر = إغلاق فوق 0.50.',
    sources: ['ID: 77215 | 30.10.2025', 'ID: 77216 | 30.10.2025', 'ID: 77214 | 30.10.2025'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_026',
    number: 26,
    category: 'مؤشر',
    title: 'قاعدة: التزم بالمؤشر ولا تشرك أدوات أخرى',
    summary: 'التصق بالمؤشر وحده لفترة تطبيق كافية.',
    details: 'ورد نصًا: «اذا التصقت بالمؤشر ولم تشرك معه اي اداه اخرى … اقلها 6 اشهر تطبيق». هذا يقرر أن مزج الأدوات يفسد المنهج، وأن التطبيق يحتاج مدة.',
    conditions: [
      'قبل الحكم على المنهج: عدم خلط أدوات تحليل أخرى.',
      'اعتبار 6 أشهر حدًا أدنى للتطبيق.'
    ],
    expectedResults: [
      'تقييم أدق لفعالية المؤشر وقوانين المدرسة.',
      'تقليل التعارض الناتج عن خلط الأدوات.'
    ],
    example: 'منع الجمع بين المؤشر وبين أدوات رسم/مؤشرات إضافية كمرجعية قرار.',
    sources: ['ID: 77179 | 28.10.2025'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_027',
    number: 27,
    category: 'مؤشر',
    title: 'قاعدة موضعية: البيع أسفل المربع',
    summary: 'إشارة مختصرة تحدد موضع البيع بالنسبة للمربع.',
    details: 'وردت رسالة قصيرة تحدد موضع البيع بالنسبة للمربع: «البيع اسفل المربع».',
    conditions: [
      'تستخدم عند وجود مربعات قياسية واضحة على الشارت.'
    ],
    expectedResults: [
      'تحديد موضع البيع بالنسبة للمربع القياسي.'
    ],
    example: 'إذا كان السعر تحت المربع/حده السفلي، يُعامل ذلك كإشارة بيع وفق العبارة.',
    sources: ['ID: 76736 | 17.10.2025'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_028',
    number: 28,
    category: 'مؤشر',
    title: 'لا تشخيص قياسي بدون المؤشر',
    summary: 'بدون المؤشر لا يمكن تشخيص السعر أو اتخاذ قرار عن المستقبل.',
    details: 'وردت عبارات صريحة: لا يوجد احتمال لتشخيص السعر بدون المؤشر، ولا تستطيع أن تتخذ قرارًا لمستقبل السعر بدونه، وأن أحكامك تصبح تقليدية وأن المؤشر يكشف مستويات مثل 0.236 و1.236 وأماكن الوقف/الانزلاق/الاندفاع.',
    conditions: [
      'إذا كان هدفك تطبيق المدرسة كما هي: وجود المؤشر جزء من المنهج.',
      'بدون المؤشر: أقصى ما يمكنك هو استنتاجات تقليدية وفق النص.'
    ],
    expectedResults: [
      'ربط التشخيص القياسي بالمؤشر كأداة أساسية.',
      'تجنب إصدار أحكام مستقبلية دون أدوات المدرسة.'
    ],
    example: 'الحكم على حركة أنها اندفاع/انزلاق/وقف بدون المؤشر يوصف بأنه تقليدي/غير دقيق وفق النص.',
    sources: ['ID: 49660 | 12.10.2024', 'ID: 70549 | 14.03.2025', 'ID: 59910 | 31.08.2024'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_029',
    number: 29,
    category: 'مؤشر',
    title: 'قاعدة تجاذب إغلاقين سلبيين',
    summary: 'تعريف التجاذب عبر سلوك الإغلاقين السلبيين باستخدام مربعات الإغلاق.',
    details: 'ورد تعريف تطبيقي للتجاذب عبر الإغلاقات: «تجاذب إغلاقين سلبيين» كطريقة توصيف مرتبطة بالمربعات.',
    conditions: [
      'يُستخدم هذا التعريف عندما تعتمد القراءة على مربعات الإغلاق.',
      'اعتبره توصيفًا مساعدًا للتجاذب وليس بديلًا عن قوانين البيئة.'
    ],
    expectedResults: [
      'توحيد توصيف التجاذب عبر الإغلاقات المتكررة.',
      'الربط بين المربعات وسلوك الإغلاق.'
    ],
    example: 'توصيف التجاذب عبر «إغلاقين سلبيين» مع الاعتماد على قراءة مربعات الإغلاق.',
    sources: ['ID: 77220 | 30.10.2025'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_030',
    number: 30,
    category: 'كوني',
    title: 'قانون 0.236 و 4.236 (أساس النظام الكوني)',
    summary: '0.236 هي النسبة الأساسية و4.236 هي المقابلة، والعلاقة بينهما ≈ 1.',
    details: 'القانون يذكر أن 0.236 × 4.236 ≈ 1، وتُستخدم هذه النسب كأساس لبناء مناطق القرار.',
    conditions: [
      'تُستخدم كنقطة انطلاق لفهم مناطق القرار داخل النظام الكوني.'
    ],
    expectedResults: [
      'ربط القياس الأساسي بعلاقة النسب المحورية في النظام.'
    ],
    example: 'التعامل مع 0.236 كنسبة أساسية و4.236 كنسبة مقابلة لبناء المناطق.',
    sources: ['DOC: الدليل | ص1–ص2'],
    chartRecipeSources: 'المصدر يعرّف 0.236 و4.236 كنسب أساس ومقابل.',
    chartRecipe: {
      inputs: ['rangeLow', 'rangeHigh'],
      overlays: [
        {
          type: 'priceLine',
          value: 'ratio(0.236)',
          label: 'الأساس 0.236',
          color: '#1565c0'
        },
        {
          type: 'priceLine',
          value: 'ratio(4.236)',
          label: 'المقابل 4.236',
          color: '#6a1b9a'
        }
      ]
    },
    tutorialSteps: []
  },
  {
    id: 'LAW_031',
    number: 31,
    category: 'كوني',
    title: 'قانون قائمة النسب الأساسية المعتمدة في النظام',
    summary: 'النظام يستخدم مجموعة نسب محددة (0.236…4.236) كمرجع للتقييم.',
    details: 'القائمة كما وردت: 0.236 / 0.382 / 0.500 / 0.618 / 0.786 / 1.000 / 1.272 / 1.618 / 2.618 / 4.236.',
    conditions: [
      'استخدم القائمة كنسب مرجعية عند قياس النطاقات داخل النظام.'
    ],
    expectedResults: [
      'توحيد مرجع النسب في التحليل.',
      'تسهيل استخدام فلاتر النظام الكوني.'
    ],
    example: 'تطبيق القائمة عند اختيار أقرب نسبة أو تقييم قوة المستوى.',
    sources: ['DOC: الدليل | ص1'],
    chartRecipeSources: 'قائمة النسب الأساسية كما وردت في الدليل.',
    chartRecipe: {
      inputs: ['rangeLow', 'rangeHigh'],
      overlays: [
        { type: 'priceLine', value: 'ratio(0.236)', label: '0.236' },
        { type: 'priceLine', value: 'ratio(0.382)', label: '0.382' },
        { type: 'priceLine', value: 'ratio(0.500)', label: '0.500' },
        { type: 'priceLine', value: 'ratio(0.618)', label: '0.618' },
        { type: 'priceLine', value: 'ratio(0.786)', label: '0.786' },
        { type: 'priceLine', value: 'ratio(1.000)', label: '1.000' },
        { type: 'priceLine', value: 'ratio(1.272)', label: '1.272' },
        { type: 'priceLine', value: 'ratio(1.618)', label: '1.618' },
        { type: 'priceLine', value: 'ratio(2.618)', label: '2.618' },
        { type: 'priceLine', value: 'ratio(4.236)', label: '4.236' }
      ]
    },
    tutorialSteps: []
  },
  {
    id: 'LAW_032',
    number: 32,
    category: 'كوني',
    title: 'قانون المنطقة الحمراء: تجنب التداول نهائيًا',
    summary: 'إذا كانت ratio < 0.236 أو ratio > 4.236 فهذه منطقة خطر مطلق.',
    details: 'القانون يضع هذه المناطق كخطر قصوى ويطلب التجنب المطلق، وتُستخدم كفلتر أول قبل أي قرار.',
    conditions: [
      'احسب النسبة قبل أي قرار ضمن النظام الكوني.',
      'إذا وقعت النسبة خارج النطاق: أوقف التداول فورًا.'
    ],
    expectedResults: [
      'حماية رأس المال من قرارات عالية الخطورة.',
      'تصفية الصفقات قبل الدخول.'
    ],
    example: 'عند وصول النسبة إلى 4.236، تُصنف الحالة منطقة حمراء ويُمنع الدخول.',
    sources: ['DOC: الدليل | ص1–ص2، ص5–ص6، ص11'],
    chartRecipeSources: 'الحدان 0.236 و4.236 معرفان كمنطقة حمراء في الدليل.',
    chartRecipe: {
      inputs: ['rangeLow', 'rangeHigh'],
      overlays: [
        {
          type: 'priceLine',
          value: 'ratio(0.236)',
          label: 'حد المنطقة الحمراء السفلي',
          color: '#d32f2f'
        },
        {
          type: 'priceLine',
          value: 'ratio(4.236)',
          label: 'حد المنطقة الحمراء العلوي',
          color: '#d32f2f'
        }
      ]
    },
    tutorialSteps: []
  },
  {
    id: 'LAW_033',
    number: 33,
    category: 'كوني',
    title: 'قانون المنطقة الآمنة/المثلى (Safe vs Optimal)',
    summary: 'المنطقة الآمنة 0.236–0.786، والمثلى (الخضراء) 0.382–0.618.',
    details: 'فلتر safe_zone_filter يميز بين الأخضر المثالي والأصفر الآمن داخل نطاق safe.',
    conditions: [
      'حدّد أولًا نطاق Safe ثم صنّف Optimal داخله.',
      'تُعطى الأولوية للمنطقة الخضراء عند تساوي الإشارات.'
    ],
    expectedResults: [
      'تحسين جودة الدخول عبر التركيز على النطاق المثالي.',
      'تقليل المخاطرة في المناطق الأقل جودة.'
    ],
    example: 'إذا كانت النسبة 0.55 فهي ضمن المنطقة المثلى (الخضراء).',
    sources: ['DOC: الدليل | ص5، ص8، ص11'],
    chartRecipeSources: 'حدود المنطقة الآمنة/المثلى كما وردت في الدليل.',
    chartRecipe: {
      inputs: ['rangeLow', 'rangeHigh'],
      overlays: [
        {
          type: 'zone',
          from: 'ratio(0.236)',
          to: 'ratio(0.786)',
          label: 'المنطقة الآمنة',
          color: 'rgba(255, 193, 7, 0.2)'
        },
        {
          type: 'zone',
          from: 'ratio(0.382)',
          to: 'ratio(0.618)',
          label: 'المنطقة المثلى',
          color: 'rgba(76, 175, 80, 0.2)'
        },
        {
          type: 'priceLine',
          value: 'ratio(0.236)',
          label: 'حد الآمن السفلي',
          color: '#f9a825'
        },
        {
          type: 'priceLine',
          value: 'ratio(0.786)',
          label: 'حد الآمن العلوي',
          color: '#f9a825'
        },
        {
          type: 'priceLine',
          value: 'ratio(0.382)',
          label: 'حد المثلى السفلي',
          color: '#2e7d32'
        },
        {
          type: 'priceLine',
          value: 'ratio(0.618)',
          label: 'حد المثلى العلوي',
          color: '#2e7d32'
        }
      ]
    },
    tutorialSteps: []
  },
  {
    id: 'LAW_034',
    number: 34,
    category: 'كوني',
    title: 'قانون تحديد أقرب نسبة + قوة المستوى (Basic Ratio Filter)',
    summary: 'يتم اعتماد أقرب نسبة وتصنيف قوة المستوى حسب المسافة (1%/2%/5%).',
    details: 'القانون يعتمد closest_ratio و distance لتصنيف القوة (قوي جدًا/قوي/متوسط/ضعيف).',
    conditions: [
      'احسب أقرب نسبة من القائمة الأساسية.',
      'قيّم المسافة لتحديد قوة المستوى.'
    ],
    expectedResults: [
      'توحيد قراءة القوة عند اختيار المستوى.',
      'إزالة العشوائية عند تقييم النسبة الأقرب.'
    ],
    example: 'إذا كانت المسافة 1% تُصنف القوة «قوي جدًا» وفق القاعدة.',
    sources: ['DOC: الدليل | ص4'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_035',
    number: 35,
    category: 'كوني',
    title: 'قانون قواعد الدخول BUY',
    summary: 'قواعد شراء محددة تعتمد على النسب والزخم والحجم.',
    details: 'القواعد كما وردت: ارتداد من 0.382 أو 0.618 مع حجم > المتوسط × 1.5 وRSI بين 30–70، أو اختراق 0.236 مع تأكيد 3 شموع وMACD إيجابي، أو توازن عند 0.500 مع اتجاه صاعد ودعم 0.382.',
    conditions: [
      'تطبيق القواعد داخل النظام الكوني كجزء من فلترة القرار.',
      'وجود توافق بين النسبة والزخم/الحجم حسب القاعدة.'
    ],
    expectedResults: [
      'إشارة شراء قوية أو مؤكدة حسب القاعدة المستخدمة.',
      'تحسين جودة الدخول مقارنة بالحدس.'
    ],
    example: 'ارتداد السعر من 0.618 مع حجم أعلى من المتوسط وRSI بين 30–70 يعطي إشارة شراء قوية.',
    sources: ['DOC: الدليل | ص3'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_036',
    number: 36,
    category: 'كوني',
    title: 'قانون قواعد الخروج SELL',
    summary: 'قواعد بيع تعتمد على الامتداد، 4.236، أو كسر 0.236.',
    details: 'القواعد تشمل: الوصول إلى 1.618 أو 2.618 مع تشبع شرائي وحجم مرتفع (بيع قوي)، الاقتراب من 4.236 مع مؤشرات خطر (بيع فوري/حمراء)، أو كسر 0.236 لأسفل مع تأكيد 3 شموع وحجم مرتفع (بيع مؤكد).',
    conditions: [
      'تحقق من النسبة والزوابع المصاحبة (حجم/تشبع).',
      'اعتمد القاعدة الأنسب للسياق.'
    ],
    expectedResults: [
      'حماية الأرباح عند الوصول للامتدادات.',
      'الخروج المبكر عند إشارات الخطر.'
    ],
    example: 'الاقتراب من 4.236 مع مؤشرات خطر يؤدي إلى بيع فوري.',
    sources: ['DOC: الدليل | ص3'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_037',
    number: 37,
    category: 'كوني',
    title: 'قانون مصفوفة القرارات وخوارزمية القرار الكوني',
    summary: 'كل نطاق نسبة له قرار وثقة وإدارة مخاطر، والخطوات تبدأ بحساب النسبة ثم الفلاتر.',
    details: 'المصفوفة تربط النسب بقرارات وثقة (مثال: <0.236 أو >4.236 تجنب، و0.382–0.618 شراء قوي). وخوارزمية القرار: حساب ratio → فلترة المنطقة الحمراء → أقرب نسبة + فلترة مناطق → فلتر زخم/حجم → نقاط قوة → قرار + ثقة + تفاصيل.',
    conditions: [
      'اتبع تسلسل الخطوات كما ورد في الخوارزمية.',
      'استخدم المصفوفة لتحديد قرار/ثقة كل نطاق.'
    ],
    expectedResults: [
      'قرار موحّد مع تفسير واضح لمستوى الثقة.',
      'خفض التردد بين قرارات متناقضة.'
    ],
    example: 'إذا كانت النسبة ضمن 0.382–0.618، تشير المصفوفة إلى قرار شراء قوي مع ثقة مرتفعة.',
    sources: ['DOC: الدليل | ص6–ص8'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_038',
    number: 38,
    category: 'ذكاء اصطناعي',
    title: 'قانون بنية النظام الذكي: 3 نماذج + تدريب تلقائي',
    summary: 'النظام الذكي يعتمد على ثلاثة نماذج ذكاء اصطناعي تعمل معًا مع تدريب تلقائي.',
    details: 'النماذج كما وردت: Random Forest Regressor لتوقع النسب، Gradient Boosting Classifier لتصنيف المناطق، وNeural Network (MLP) لاتخاذ القرار مع Auto Training System.',
    conditions: [
      'يُستخدم هذا القانون لفهم بنية النظام الذكي قبل تطبيقه.',
      'يُعد أساسًا لبقية قوانين طبقة الذكاء الاصطناعي.'
    ],
    expectedResults: [
      'وضوح دور كل نموذج داخل النظام.',
      'تفسير أفضل لمخرجات الطبقة الذكية.'
    ],
    example: 'تصنيف المناطق يتم عبر Gradient Boosting بينما القرار النهائي يعتمد على شبكة عصبية.',
    sources: ['DOC: التقرير | ص1'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_039',
    number: 39,
    category: 'ذكاء اصطناعي',
    title: 'قانون دمج الطبقات 50%/30%/20%',
    summary: 'القرار النهائي = دمج التحليل التقليدي وAI والسياق السوقي بأوزان محددة.',
    details: 'النظام يدمج (تقليدي + AI + سياق سوقي) بأوزان 50%/30%/20% كما ورد في التقرير.',
    conditions: [
      'اعتمد الدمج قبل إصدار القرار النهائي.',
      'لا تُهمِل الطبقة التقليدية حتى مع قوة AI.'
    ],
    expectedResults: [
      'قرار أكثر توازنًا بين القياس والذكاء الاصطناعي.',
      'تقليل التحيّز لطبقة واحدة.'
    ],
    example: 'إذا كانت طبقة AI قوية لكن السياق السوقي ضعيف، يخفض الدمج حدة القرار.',
    sources: ['DOC: التقرير | ص1'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_040',
    number: 40,
    category: 'ذكاء اصطناعي',
    title: 'قانون فلترة المناطق داخل النظام الذكي',
    summary: 'فلترة المناطق (أحمر/أخضر/أصفر/برتقالي) تعمل كفلتر حماية متعدد الطبقات.',
    details: 'النظام الذكي يستخدم CosmicZoneFilter كحماية إضافية قبل تنفيذ القرار.',
    conditions: [
      'طبّق الفلتر قبل أي تنفيذ تلقائي.',
      'المناطق الحمراء تُعطل القرار مباشرة.'
    ],
    expectedResults: [
      'رفع مستوى الأمان في القرارات الآلية.',
      'تقليل التعرّض لمناطق الخطر.'
    ],
    example: 'حتى مع إشارة AI، يتم إيقاف القرار إذا كانت المنطقة حمراء.',
    sources: ['DOC: التقرير | ص2'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_041',
    number: 41,
    category: 'ذكاء اصطناعي',
    title: 'قانون تجنب المناطق الخطرة تلقائيًا',
    summary: 'النظام يطبق تجنبًا تلقائيًا للمناطق الخطرة كقاعدة أمان.',
    details: 'التقرير يذكر أن تجنب المناطق الخطرة ميزة تنافسية وحاجز أمان أساسي.',
    conditions: [
      'يُفعّل التجنب تلقائيًا عند تصنيف المنطقة خطرة.',
      'لا يُستثنى هذا القانون إلا بتحديث رسمي.'
    ],
    expectedResults: [
      'تقليل الصفقات في البيئات عالية الخطورة.',
      'تحسين انضباط النظام.'
    ],
    example: 'عند تصنيف المنطقة خطرة، تُلغى إشارة الدخول حتى لو كانت مؤشرات أخرى إيجابية.',
    sources: ['DOC: التقرير | ص4'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_042',
    number: 42,
    category: 'ذكاء اصطناعي',
    title: 'قانون تفسير الثقة قبل التنفيذ',
    summary: 'التنفيذ مرتبط بمستوى الثقة: 85%+ فوري، 70–85 بحذر، وأقل من ذلك تحذيري.',
    details: 'التقرير يربط قرار التنفيذ بدرجات الثقة ويحدد عتبات واضحة للسلوك.',
    conditions: [
      'تحقق من نسبة الثقة قبل أي تنفيذ.',
      'التزم بسلوك التنفيذ المحدد لكل نطاق.'
    ],
    expectedResults: [
      'قرارات أكثر اتساقًا مع مستوى الثقة.',
      'تقليل الدخول في حالات الثقة الضعيفة.'
    ],
    example: 'إذا كانت الثقة 88% يتم التنفيذ الفوري وفق القاعدة.',
    sources: ['DOC: التقرير | ص4'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_043',
    number: 43,
    category: 'ذكاء اصطناعي',
    title: 'قانون إدارة المخاطر الديناميكية حسب الثقة',
    summary: 'المخاطرة تبدأ منخفضة جدًا وتزداد فقط مع الثقة العالية جدًا.',
    details: 'التفصيل كما ورد: أحمر 0.00% (تجنب)، ثقة متوسطة 0.06%، ثقة جيدة 0.09%، ثقة عالية جدًا 0.15%.',
    conditions: [
      'اضبط نسبة المخاطرة وفق مستوى الثقة.',
      'التزم بالحدود القصوى المذكورة.'
    ],
    expectedResults: [
      'حماية رأس المال عند انخفاض الثقة.',
      'رفع المخاطرة تدريجيًا فقط عند ثقة عالية.'
    ],
    example: 'عند ثقة جيدة تُحدد المخاطرة بـ 0.09% من رأس المال.',
    sources: ['DOC: التقرير | ص3–ص5'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_044',
    number: 44,
    category: 'ذكاء اصطناعي',
    title: 'قانون النظام مساعد وليس بديلًا',
    summary: 'استخدم النظام الذكي كمساعد قرار وليس بديلًا للخبرة.',
    details: 'القانون يشدد على أن النظام يقدم دعمًا تحليليًا، لكن القرار النهائي يحتاج خبرة بشرية.',
    conditions: [
      'لا تُسلّم القرار النهائي بالكامل للنظام.',
      'استخدم الخبرة الشخصية لتأكيد القرار.'
    ],
    expectedResults: [
      'تقليل الاعتماد الأعمى على الذكاء الاصطناعي.',
      'تحسين جودة القرار عبر الدمج بين الخبرة والنظام.'
    ],
    example: 'حتى مع توصية النظام، يجب مراجعة السياق قبل التنفيذ.',
    sources: ['DOC: التقرير | ص6'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_045',
    number: 45,
    category: 'مشترك',
    title: 'قانون «الأبعاد السبعة» وعدم وجود بعد ثامن',
    summary: 'هناك سبعة أبعاد/بيئات أساسية، والبعد الثامن يعني الحتمية وتوقف الحركة.',
    details: 'ورد نصًا أن المدرسة تشرح الأبعاد السبعة وتربطها بحركة السعر، وأنه يستحيل وجود بعد ثامن لأنه يعني الحتمية ولو وجد لتوقفت الأسعار عن الحركة.',
    conditions: [
      'استخدمه كقانون فلسفي يفسر غياب الضمانات المطلقة.',
      'يربط هذا القانون بين البيئات واحتمالية الحركة.'
    ],
    expectedResults: [
      'ترسيخ أن الاحتمالات تبقى مفتوحة.',
      'تفسير سبب عدم وجود يقين مطلق.'
    ],
    example: 'ربط البعد الثامن بالحتمية يشرح لماذا «لا شك» ليست جبريّة.',
    sources: ['ID: 60187 | 27.11.2024', 'ID: 79020 | 15.01.2026'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_046',
    number: 46,
    category: 'مشترك',
    title: 'قانون الاتزان: الاتزان = 0.236 (ترابط مزدوج)',
    summary: 'لا اتزان بدون 0.236 ولا 0.236 بدون اتزان.',
    details: 'هذا القانون يربط بين المدرسة والمؤشر: المدرسة تفسر الاتزان عبر 0.236 والمؤشر يكشف قياسه على الشارت.',
    conditions: [
      'عند فقد الاتزان أو الخلل راجع موقع 0.236.',
      'اعتبر 0.236 محور الاتزان عند أي قياس.'
    ],
    expectedResults: [
      'توحيد تفسير الاتزان عبر الأداة والقانون.',
      'تسريع التشخيص عند حدوث خلل.'
    ],
    example: 'اعتبار 0.236 «فصل الخطاب» في الفهم التشخيصي.',
    sources: ['ID: 73352 | 11.08.2025', 'ID: 78251 | 21.12.2025', 'ID: 70549 | 14.03.2025'],
    chartRecipeSources: 'تعريف الاتزان = 0.236 ورد نصًا في المصادر.',
    chartRecipe: {
      inputs: ['rangeLow', 'rangeHigh'],
      overlays: [
        {
          type: 'priceLine',
          value: 'ratio(0.236)',
          label: 'اتزان 0.236',
          color: '#2e7d32'
        }
      ]
    },
    tutorialSteps: []
  },
  {
    id: 'LAW_047',
    number: 47,
    category: 'مشترك',
    title: 'قانون العلاقات القياسية بين النسب',
    summary: 'هناك علاقات حسابية ثابتة مثل 0.382+0.382=0.764 و4.236 مرادف 100.',
    details: 'وردت معادلات مختصرة تشير لاستخدام علاقات ثابتة بين القياسات في الحسابات والأهداف.',
    conditions: [
      'تُستخدم عند تحويل القياسات أو تقدير الأهداف.',
      'تُعامل كقواعد تشغيلية داخل النظام.'
    ],
    expectedResults: [
      'تسهيل تحويل القياسات إلى مكافئاتها.',
      'توحيد لغة القياس عند تقدير الأهداف.'
    ],
    example: 'استخدام 4.236 كمرادف للـ 100 ضمن لغة القياس.',
    sources: ['ID: 78241 | 21.12.2025', 'ID: 78245 | 21.12.2025'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  },
  {
    id: 'LAW_048',
    number: 48,
    category: 'مشترك',
    title: 'قانون تميّز القياسات وشبهها بالفيبوناتشي',
    summary: 'القياسات (0.236/0.764/1.236) تشبه الفيبوناتشي لكنها ضمن نظام المدرسة.',
    details: 'ورد نصًا أن الطريقة هي الوحيدة التي أنتجت هذه القياسات وتشبه الفيبوناتشي، ويُستخدم ذلك لتفسير خلفية القياسات.',
    conditions: [
      'استخدمه كبند تعريفي للمنهج لا كقاعدة دخول مباشرة.',
      'يربط بين فلسفة المدرسة والقياس العددي.'
    ],
    expectedResults: [
      'توضيح الخلفية النظرية للقياسات.',
      'تحسين فهم الطالب لمصدر النسب.'
    ],
    example: 'ربط القياسات بفيبوناتشي لتسهيل فهم الخلفية للمتعلم.',
    sources: ['ID: 77434 | 31.10.2025', 'ID: 60187 | 27.11.2024'],
    chartRecipeSources: "انظر مصادر القانون أعلاه.",
    chartRecipe: { inputs: [], overlays: [] },
    tutorialSteps: []
  }
];

const fallbackRecipe = { inputs: [], overlays: [] };

export const laws = rawLaws.map((law) => {
  if (law.chartRecipe || (Array.isArray(law.tutorialSteps) && law.tutorialSteps.length)) {
    return law;
  }

  return {
    ...law,
    chartRecipe: fallbackRecipe,
    tutorialSteps: Array.isArray(law.tutorialSteps) ? law.tutorialSteps : []
  };
});

export const getLawById = (id) => laws.find(law => law.id === id);
export const getLawByNumber = (number) => laws.find(law => law.number === number);
export const getLawsByCategory = (category) => laws.filter(law => law.category === category);
